// extracted by mini-css-extract-plugin
export default {"head":"Content_head__ZTsQ8"};